import Vue from 'vue';
import {
  GENERAL_QUERY,
  LATEST_APP_DATA_QUERY,
  LAST_MINUTE_DATA_QUERY
} from '../../queries/queries';

let getQueryVariables = obj => {
  return {
    deviceSerial: obj.deviceSerialNumber,
    granularity: obj.requestGranularity,
    granularityFull: obj.requestGranularityFull || obj.requestGranularity,
    startTime: obj.requestStartTime,
    endTime: obj.requestEndTime,
    version: obj.version
  };
};

export default {
  /**
   * Gets graphql data from a given device.
   *
   * @returns {Promise}
   */
  getBatteryIOData(queryObject) {
    return Vue.prototype.$graphqlClient
      .query({
        query: GENERAL_QUERY,
        variables: getQueryVariables(queryObject),
        fetchPolicy: 'no-cache' // if used for real-time
      })
      .then(response => response.data.deviceAppData);
  },

  /**
   * Gets the latest application data.
   *
   * @returns {Promise}
   */
  getLatestAppData(queryObject) {
    return Vue.prototype.$graphqlClient
      .query({
        query: LATEST_APP_DATA_QUERY,
        variables: getQueryVariables(queryObject),
        fetchPolicy: 'no-cache' // if used for real-time
      })
      .then(response => response.data.deviceAppData);
  },

  /**
   * Gets the last minute  data.
   *
   * @returns {Promise}
   */
  getLastMinuteData(queryObject) {
    return Vue.prototype.$graphqlClient
      .query({
        query: LAST_MINUTE_DATA_QUERY,
        variables: getQueryVariables(queryObject),
        fetchPolicy: 'no-cache' // if used for real-time
      })
      .then(response => response.data);
  }
};
